/* ==========================================================================
   BANCO — Ajout au panier : la chorégraphie commune (aucune dépendance)
   Charger en defer dans theme.liquid, après banco-animations.js.
   Styles : banco-ajout-panier.css

   Ce fichier ne décide jamais d'un ajout : il met en scène celui que les
   autres viennent de faire. Quatre points d'entrée, tous facultatifs et sans
   effet de bord si la page ne s'y prête pas :

     BancoPanier.vol({ depuis, image })   l'article vole jusqu'au panier
     BancoPanier.arrivee()                l'icône du panier accuse réception
     BancoPanier.pastille(sections)       le compteur se met à jour, animé
     BancoPanier.coche(bouton)            la coche de confirmation du bouton
     BancoPanier.celebrer({...})          les quatre d'un coup, dans l'ordre

   La fiche produit est branchée automatiquement (événement cartUpdate du
   thème). Les autres chemins d'ajout — ajout rapide de la grille, suggestions
   du panier, configurateur — appellent celebrer() eux-mêmes.
   ========================================================================== */
(function () {
  'use strict';

  var reduit = window.matchMedia('(prefers-reduced-motion: reduce)');
  function mouvementReduit() { return reduit.matches; }

  /* Le vol dure ce que dure un geste de la main : assez pour être suivi des
     yeux, trop court pour faire attendre. */
  var VOL_DUREE = 720;
  /* Taille de la vignette en vol : plafonnée sur son grand côté, sinon la photo
     d'une fiche produit occuperait le tiers de l'écran en partant. */
  var VOL_TAILLE_MAX = 168;
  var VOL_TAILLE_MIN = 44;
  /* Départ depuis le bouton : la vignette est carrée. Avec une photo dedans
     elle a droit à un peu plus de place ; sans photo, une simple pastille. */
  var VOL_CARRE = 96;
  var VOL_PASTILLE = 56;
  /* Diamètre d'arrivée, à peu près celui de l'icône du panier. */
  var VOL_ARRIVEE = 26;

  function cible() {
    return document.getElementById('cart-icon-bubble');
  }

  /* L'en-tête escamotable se dérobe au défilement : sans ce rappel, l'article
     volerait vers une icône hors de l'écran. Le thème fait de même avant
     d'ouvrir la pastille de confirmation. */
  function revelerEntete() {
    var sticky = document.querySelector('sticky-header');
    if (sticky && typeof sticky.reveal === 'function') {
      try { sticky.reveal(); } catch (e) {}
    }
  }

  /* Le retour de l'en-tête est une transition : mesuré dans la même image, le
     panier est encore à moitié dehors et le vol renonce. On lui laisse le temps
     de se poser — au plus 400 ms, et pas une image de plus que nécessaire. */
  var CIBLE_ATTENTE_MAX = 400;

  function attendreCible() {
    revelerEntete();
    var icone = cible();
    if (!icone) return Promise.resolve(null);
    var limite = Date.now() + CIBLE_ATTENTE_MAX;
    return new Promise(function (resolve) {
      (function verifier() {
        var r = icone.getBoundingClientRect();
        if (rectVisible(r)) { resolve(r); return; }
        if (Date.now() > limite) { resolve(null); return; }
        requestAnimationFrame(verifier);
      })();
    });
  }

  function rectVisible(r) {
    if (!r || !r.width || !r.height) return false;
    var cx = r.left + r.width / 2;
    var cy = r.top + r.height / 2;
    return cx > -40 && cy > -40 &&
      cx < window.innerWidth + 40 && cy < window.innerHeight + 40;
  }

  /* Une image de la taille d'une photo d'article — ni pictogramme, ni logo de
     moyen de paiement. */
  function grandeImage(racine) {
    if (!racine || !racine.querySelectorAll) return null;
    var imgs = racine.querySelectorAll('img');
    for (var i = 0; i < imgs.length; i++) {
      var r = imgs[i].getBoundingClientRect();
      if (r.width >= 44 && r.height >= 44) return imgs[i];
    }
    return null;
  }

  /* Photo à faire voler : celle de l'article. On s'éloigne du bouton de proche
     en proche jusqu'à rencontrer une photo — sur une fiche produit, la galerie
     est dans une autre colonne que le bouton d'achat, donc il faut remonter
     jusqu'au bloc produit entier. (S'arrêter au premier ancêtre nommé, comme
     product-info, ne trouvait rien : cette colonne ne contient aucune photo.) */
  function imageDeLArticle(bouton) {
    if (!bouton) return null;
    var explicite = bouton.getAttribute('data-banco-vol-image');
    if (explicite) return explicite;

    var noeud = bouton.parentElement;
    for (var n = 0; noeud && noeud !== document.body && n < 9; n++) {
      var img = grandeImage(noeud);
      if (img) return img;
      noeud = noeud.parentElement;
    }
    return grandeImage(document.querySelector('.product__media-wrapper, .product, main'));
  }

  /* Rectangle de départ : la photo si elle est encore à l'écran, sinon le
     bouton — qu'on vient forcément de toucher, donc visible. On retient
     LEQUEL des deux a servi : le cadrage de la vignette en dépend (voir
     lancerVol), un bouton large ne donnant pas une forme d'article. */
  function rectDepart(source, bouton) {
    if (source && source.getBoundingClientRect) {
      var r = source.getBoundingClientRect();
      if (rectVisible(r)) return { rect: r, depuisImage: true };
    }
    if (bouton && bouton.getBoundingClientRect) {
      var rb = bouton.getBoundingClientRect();
      if (rectVisible(rb)) return { rect: rb, depuisImage: false };
    }
    return null;
  }

  function sourceHTML(image) {
    if (!image) return null;
    if (typeof image === 'string') {
      var img = document.createElement('img');
      img.src = image;
      img.alt = '';
      return img;
    }
    if (image.tagName === 'IMG') {
      var copie = document.createElement('img');
      copie.src = image.currentSrc || image.src;
      copie.alt = '';
      return copie;
    }
    if (image.tagName === 'CANVAS') {
      try {
        var depuisCanvas = document.createElement('img');
        depuisCanvas.src = image.toDataURL('image/png');
        depuisCanvas.alt = '';
        return depuisCanvas;
      } catch (e) {
        /* canvas « teinté » (image servie sans en-tête CORS) : on renonce à
           l'image, le vol se fera sur une pastille unie. */
        return null;
      }
    }
    return null;
  }

  /* ---------------- Le vol ----------------
     Résout quand l'article s'est posé (ou tout de suite s'il n'y a rien à
     animer) : l'appelant peut enchaîner sans connaître nos durées. */
  function vol(opts) {
    opts = opts || {};
    if (mouvementReduit() || !document.body) return Promise.resolve(false);

    var bouton = opts.bouton || null;
    var image = opts.image !== undefined ? opts.image : imageDeLArticle(bouton);
    var depart = opts.rect;
    /* un rectangle fourni par l'appelant est celui de l'aperçu de l'article */
    var depuisImage = opts.rectEstImage !== undefined ? opts.rectEstImage : true;
    if (!depart) {
      var d = rectDepart(opts.depuis || (image && image.tagName ? image : null), bouton);
      if (!d) return Promise.resolve(false);
      depart = d.rect;
      depuisImage = d.depuisImage;
    }

    /* la course n'est calculée qu'une fois le panier réellement à l'écran :
       une image d'avance et l'article partirait vers un point hors champ */
    return attendreCible().then(function (rCible) {
      if (!rCible) return false;
      return lancerVol(depart, image, rCible, depuisImage);
    });
  }

  function lancerVol(depart, image, rCible, depuisImage) {
    /* Toujours un enfant, même sans photo (une pastille pleine fait l'affaire) :
       le thème masque les div vides — `div:empty { display: none }` dans
       base.css — et une vignette vide ne volerait jamais. */
    var contenu = sourceHTML(image);
    var avecPhoto = !!contenu;
    if (!contenu) {
      contenu = document.createElement('span');
      contenu.className = 'banco-vol-panier-pastille';
    }

    /* Cadre de départ. Quand on part de la photo elle-même, on garde son
       cadrage et seule la taille est ramenée à la raison : la vignette se
       superpose exactement à la photo de la page, et le client voit son article
       se décoller — un carré recadré au milieu d'une grande photo, lui, passait
       pour une tuile posée dessus. Quand on part du bouton (photo hors écran,
       ou pas de photo du tout), c'est un carré : le cadrage d'un bouton large
       et bas donnerait une meurtrière, pas un article. */
    var largeur, hauteur;
    if (avecPhoto && depuisImage) {
      var facteur = Math.min(1, VOL_TAILLE_MAX / Math.max(depart.width, depart.height));
      largeur = Math.max(VOL_TAILLE_MIN, Math.round(depart.width * facteur));
      hauteur = Math.max(VOL_TAILLE_MIN, Math.round(depart.height * facteur));
    } else {
      largeur = hauteur = avecPhoto ? VOL_CARRE : VOL_PASTILLE;
    }

    var x0 = depart.left + depart.width / 2 - largeur / 2;
    var y0 = depart.top + depart.height / 2 - hauteur / 2;

    var dx = (rCible.left + rCible.width / 2) - (x0 + largeur / 2);
    var dy = (rCible.top + rCible.height / 2) - (y0 + hauteur / 2);
    var echelle = VOL_ARRIVEE / Math.max(largeur, hauteur);

    var vignette = document.createElement('div');
    vignette.className = 'banco-vol-panier';
    vignette.style.left = x0 + 'px';
    vignette.style.top = y0 + 'px';
    vignette.style.width = largeur + 'px';
    vignette.style.height = hauteur + 'px';
    vignette.appendChild(contenu);
    document.body.appendChild(vignette);

    /* Onde à l'endroit du départ : le regard sait d'où l'article est parti. */
    var onde = document.createElement('div');
    onde.className = 'banco-vol-panier-onde';
    onde.style.left = x0 + 'px';
    onde.style.top = y0 + 'px';
    onde.style.width = largeur + 'px';
    onde.style.height = hauteur + 'px';
    document.body.appendChild(onde);

    var finir = function () {
      if (vignette.parentNode) vignette.parentNode.removeChild(vignette);
      if (onde.parentNode) onde.parentNode.removeChild(onde);
    };

    /* Sans l'API d'animation (très vieux navigateur) : pas de vol, pas de
       vignette figée à l'écran. */
    if (typeof vignette.animate !== 'function') { finir(); return Promise.resolve(false); }

    /* Cloche du vol : l'article s'élève un peu avant de retomber dans le
       panier. Un trait droit ferait « téléportation », pas « geste ». */
    var distance = Math.hypot(dx, dy) || 1;
    var cloche = Math.max(28, Math.min(110, distance * 0.2));

    onde.animate(
      [
        { transform: 'scale(1)', opacity: 0.55 },
        { transform: 'scale(1.6)', opacity: 0 }
      ],
      { duration: 520, easing: 'cubic-bezier(0.2, 0.7, 0.3, 1)', fill: 'forwards' }
    );

    var animation = vignette.animate(
      [
        {
          transform: 'translate(0px, 0px) scale(1) rotate(0deg)',
          opacity: 1,
          borderRadius: '8px',
          offset: 0
        },
        {
          transform: 'translate(' + (dx * 0.48).toFixed(1) + 'px, ' + (dy * 0.48 - cloche).toFixed(1) + 'px) ' +
            'scale(' + (echelle + (1 - echelle) * 0.42).toFixed(3) + ') rotate(-5deg)',
          opacity: 1,
          borderRadius: '26%',
          offset: 0.5
        },
        {
          transform: 'translate(' + dx.toFixed(1) + 'px, ' + dy.toFixed(1) + 'px) ' +
            'scale(' + echelle.toFixed(3) + ') rotate(4deg)',
          opacity: 0.25,
          borderRadius: '50%',
          offset: 1
        }
      ],
      { duration: VOL_DUREE, easing: 'cubic-bezier(0.34, 0.06, 0.22, 1)', fill: 'forwards' }
    );

    return new Promise(function (resolve) {
      /* L'icône réagit juste avant la fin du vol : l'accusé de réception doit
         coïncider avec l'impact, pas le suivre. */
      setTimeout(arrivee, Math.max(0, VOL_DUREE - 90));
      var termine = false;
      var fin = function () {
        if (termine) return;
        termine = true;
        finir();
        resolve(true);
      };
      animation.onfinish = fin;
      animation.oncancel = fin;
      /* filet : une animation dont l'onglet passe en arrière-plan peut ne
         jamais notifier sa fin — la vignette ne doit pas rester collée. */
      setTimeout(fin, VOL_DUREE + 400);
    });
  }

  /* ---------------- L'arrivée ---------------- */
  function arrivee() {
    var icone = cible();
    if (!icone || mouvementReduit()) return;
    icone.classList.remove('banco-panier-recu');
    /* forcer le navigateur à reprendre l'animation depuis le début si deux
       ajouts se suivent de près */
    void icone.offsetWidth;
    icone.classList.add('banco-panier-recu');
    setTimeout(function () { icone.classList.remove('banco-panier-recu'); }, 700);
  }

  /* ---------------- Le compteur ----------------
     Deux temps séparés à dessein : le fragment est cherché tout de suite (le
     réseau travaille pendant le vol), mais il n'est posé qu'à l'arrivée de
     l'article. C'est l'article qui fait monter le chiffre, pas la requête.

     `sections` : le fragment déjà renvoyé par /cart/add.js quand l'appelant a
     demandé `sections: 'cart-icon-bubble'`. Sinon on va le chercher. */
  function chargerPastille(sections) {
    if (sections && sections['cart-icon-bubble']) {
      return Promise.resolve(sections['cart-icon-bubble']);
    }
    return fetch('/?sections=cart-icon-bubble')
      .then(function (r) { return r.json(); })
      .then(function (d) { return (d && d['cart-icon-bubble']) || null; })
      .catch(function () { return null; });
  }

  function poserPastille(html) {
    var icone = cible();
    if (!icone || !html) return false;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.querySelector('.shopify-section') || doc.body;
    if (!section) return false;
    icone.innerHTML = section.innerHTML;
    animerPastille();
    return true;
  }

  function pastille(sections) {
    return chargerPastille(sections).then(poserPastille);
  }

  /* Le compteur a déjà été remplacé par quelqu'un d'autre (le thème le fait
     lui-même après un ajout depuis la fiche produit) : on n'anime que. */
  function animerPastille() {
    var icone = cible();
    if (!icone) return;
    icone.classList.remove('banco-pastille-maj');
    void icone.offsetWidth;
    icone.classList.add('banco-pastille-maj');
    setTimeout(function () { icone.classList.remove('banco-pastille-maj'); }, 620);
  }

  /* ---------------- La coche du bouton ----------------
     Le libellé n'est jamais réécrit : il s'efface derrière la coche, puis
     revient. Rien à traduire, rien à remettre en place si la page change. */
  var COCHE_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
    '<circle cx="12" cy="12" r="10.4"/>' +
    '<path d="M7 12.4l3.4 3.4L17 8.9"/>' +
    '</svg>';

  function coche(bouton, duree) {
    if (!bouton || bouton.querySelector('.banco-ajout-coche')) return;
    var marque = document.createElement('span');
    marque.className = 'banco-ajout-coche';
    marque.setAttribute('aria-hidden', 'true');
    marque.innerHTML = COCHE_SVG;
    bouton.appendChild(marque);
    bouton.classList.add('banco-ajout-ok');
    setTimeout(function () {
      bouton.classList.remove('banco-ajout-ok');
      if (marque.parentNode) marque.parentNode.removeChild(marque);
    }, duree || 1500);
  }

  /* ---------------- L'ondelette d'appui ---------------- */
  function onde(bouton, evt) {
    if (!bouton || mouvementReduit()) return;
    var r = bouton.getBoundingClientRect();
    var x = evt && evt.clientX ? evt.clientX - r.left : r.width / 2;
    var y = evt && evt.clientY ? evt.clientY - r.top : r.height / 2;
    var o = document.createElement('span');
    o.className = 'banco-onde-appui';
    o.setAttribute('aria-hidden', 'true');
    o.style.setProperty('--banco-onde-x', x + 'px');
    o.style.setProperty('--banco-onde-y', y + 'px');
    /* le rognage n'est posé que le temps de l'onde — voir .banco-onde-hote */
    bouton.classList.add('banco-onde-hote');
    bouton.appendChild(o);
    setTimeout(function () {
      if (o.parentNode) o.parentNode.removeChild(o);
      bouton.classList.remove('banco-onde-hote');
    }, 700);
  }

  /* ---------------- La séquence complète ----------------
     opts : { bouton, image, rect, depuis, sections, pastille: false, coche: false }
     `coche: false` pour un bouton qui porte déjà sa propre confirmation
     (l'ajout rapide de la grille bascule son + en ✓ tout seul).
     Résout quand l'article s'est posé — pour enchaîner (fermer un panneau,
     par exemple) une fois le geste terminé. */
  function celebrer(opts) {
    opts = opts || {};
    if (opts.bouton && opts.coche !== false) coche(opts.bouton, opts.dureeCoche);
    /* le fragment part chercher le nouveau compte pendant que l'article vole */
    var fragment = opts.pastille === false
      ? Promise.resolve(null)
      : chargerPastille(opts.sections);
    return vol(opts).then(function (aVole) {
      if (!aVole) arrivee();
      return fragment.then(function (html) {
        /* posé maintenant, à l'arrivée. Sans fragment (le thème a déjà remis
           le compteur à jour lui-même), on anime seulement. */
        if (!poserPastille(html)) animerPastille();
        return aVole;
      });
    });
  }

  window.BancoPanier = {
    vol: vol,
    arrivee: arrivee,
    pastille: pastille,
    chargerPastille: chargerPastille,
    poserPastille: poserPastille,
    animerPastille: animerPastille,
    coche: coche,
    onde: onde,
    celebrer: celebrer,
    imageDeLArticle: imageDeLArticle,
    mouvementReduit: mouvementReduit
  };

  /* ======================================================================
     Branchement automatique de la fiche produit
     Le formulaire du thème (product-form.js) publie `cartUpdate` après un
     ajout réussi, mais sans dire quel bouton a été pressé : on le retient au
     clic, en phase de capture, avant que le formulaire ne s'en saisisse.
     ====================================================================== */
  var dernierAppui = null;

  document.addEventListener(
    'click',
    function (e) {
      var bouton = e.target && e.target.closest
        ? e.target.closest('.product-form__submit, [name="add"]')
        : null;
      if (!bouton || bouton.hasAttribute('disabled')) return;
      if (bouton.getAttribute('aria-disabled') === 'true') return;
      var photo = imageDeLArticle(bouton);
      /* le point de départ est figé maintenant : après l'ajout, la pastille de
         confirmation peut avoir décalé la mise en page */
      var depart = rectDepart(photo, bouton);
      dernierAppui = {
        bouton: bouton,
        image: photo,
        rect: depart ? depart.rect : null,
        rectEstImage: depart ? depart.depuisImage : false,
        temps: Date.now()
      };
      onde(bouton, e);
    },
    true
  );

  function brancherFicheProduit() {
    /* `subscribe` (pubsub.js) est une déclaration de fonction, donc bien posée
       sur window ; `PUB_SUB_EVENTS` (constants.js) est un `const`, c'est-à-dire
       une liaison globale qui n'apparaît PAS sur window — d'où l'accès par
       identifiant nu, sous garde typeof. */
    if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (evt) {
      /* seuls les ajouts : les changements de quantité du panier publient le
         même événement depuis d'autres sources */
      if (!evt || evt.source !== 'product-form') return;
      var appui = dernierAppui;
      dernierAppui = null;
      /* un ajout sans clic retenu (soumission au clavier, appel programmé) :
         on garde l'accusé de réception, sans point de départ pour le vol */
      if (!appui || Date.now() - appui.temps > 30000) {
        animerPastille();
        arrivee();
        return;
      }
      celebrer({
        bouton: appui.bouton,
        image: appui.image,
        rect: appui.rect,
        rectEstImage: appui.rectEstImage,
        /* le thème vient de remplacer le compteur lui-même (renderContents) :
           inutile de le retélécharger, on anime seulement */
        pastille: false
      });
    });
    return true;
  }

  /* pubsub.js et constants.js sont chargés en defer comme nous, mais avant :
     au cas où l'ordre changerait, on réessaie une fois le document prêt. */
  if (!brancherFicheProduit()) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', brancherFicheProduit);
    } else {
      setTimeout(brancherFicheProduit, 0);
    }
  }
})();
